module.exports = __webpack_public_path__ + "media/images/suppliers/advansta-838ef27899aaa49c6242dd4477f75e29.png";